import { NgFor, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Course } from '@tanzspass/shared';
import { CourseService } from '../../services/course.service';
import { TvScreenService } from '../../services/tv-screen.service';

@Component({
  selector: 'ts-infosystem-featured-courses',
  templateUrl: './infosystem-featured-courses.component.html',
  styleUrls: ['./infosystem-featured-courses.component.css'],
  imports: [NgIf, NgFor],
})
export class InfosystemFeaturedCoursesComponent {
  @Input() schoolId: number;
  @Input() showInOverview: boolean;
  courses: Course[] = [];

  constructor(
    private tvScreenSrv: TvScreenService,
    private courseSrv: CourseService,
  ) {
    this.tvScreenSrv.payload$.pipe(takeUntilDestroyed()).subscribe((payload) => {
      this.courses = this.courseSrv
        .convertCourses(payload?.featuredCourses ?? [])
        .filter((course) => course?.course_start_dates.length > 0)
        .slice(0, 3);
    });
  }
}
